"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var components_1 = require("stremio/components");
var Details_less_1 = __importDefault(require("./Details.less"));
var Details = function (_a) {
    var selected = _a.selected, items = _a.items;
    var t = (0, react_i18next_1.useTranslation)().t;
    var videos = (0, react_1.useMemo)(function () {
        var _a, _b;
        return (_b = (_a = items.find(function (_a) {
            var date = _a.date;
            return date.day === (selected === null || selected === void 0 ? void 0 : selected.day);
        })) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : [];
    }, [selected, items]);
    return (react_1.default.createElement("div", { className: Details_less_1.default['details'] },
        videos.map(function (_a) {
            var id = _a.id, name = _a.name, season = _a.season, episode = _a.episode, deepLinks = _a.deepLinks;
            return (react_1.default.createElement(components_1.Button, { className: Details_less_1.default['video'], key: id, href: deepLinks.metaDetailsStreams },
                react_1.default.createElement("div", { className: Details_less_1.default['name'] }, name),
                react_1.default.createElement("div", { className: Details_less_1.default['info'] },
                    "S",
                    season,
                    "E",
                    episode),
                react_1.default.createElement(react_2.default, { className: Details_less_1.default['icon'], name: 'play' })));
        }),
        !videos.length ?
            react_1.default.createElement("div", { className: Details_less_1.default['placeholder'] }, t('CALENDAR_NO_NEW_EPISODES'))
            :
                null));
};
exports.default = Details;
